import { render, staticRenderFns } from "./MedicallyNecessary.vue?vue&type=template&id=6b9977f6&scoped=true"
import script from "./MedicallyNecessary.vue?vue&type=script&lang=js"
export * from "./MedicallyNecessary.vue?vue&type=script&lang=js"
import style0 from "./MedicallyNecessary.vue?vue&type=style&index=0&id=6b9977f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9977f6",
  null
  
)

export default component.exports